<div id="viewDataMappingDialog"
     class="modal fade"
     tabindex="-1"
     role="dialog">

  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <!-- ================= HEADER ================= -->
      <div class="modal-header">
        <button type="button" class="close" (click)="hide()">
          <span>&times;</span>
        </button>
        <h4 class="modal-title">
          {{ header?.mappingName }}
        </h4>
      </div>

      <!-- ================= BODY ================= -->
      <div class="modal-body">

        <div *ngIf="isLoading" class="text-center">
          <i class="fa fa-spinner fa-spin"></i> Loading properties...
        </div>

        <table *ngIf="!isLoading"
               class="table table-bordered table-hover">

          <thead>
            <tr>
              <th>Property Name</th>
              <th class="text-center">Mapped</th>
              <th class="text-center">Static</th>
              <th>Value / Column</th>
              <th class="text-center">Lookup</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let p of properties">

              <!-- Property -->
              <td>{{ p.propertyName }}</td>

              <!-- Mapped -->
              <td class="text-center">
                <i *ngIf="p.isMapped" class="fa fa-check text-success"></i>
                <span *ngIf="!p.isMapped" class="text-muted">No</span>
              </td>

              <!-- Static -->
              <td class="text-center">
                <ng-container *ngIf="p.isMapped; else notMapped">
                  {{ p.isStatic ? 'Yes' : 'No' }}
                </ng-container>
              </td>

              <!-- Value / Column -->
              <td>
                <ng-container *ngIf="p.isMapped; else notMapped">
                  {{ p.valueOrColumn || '-' }}
                </ng-container>
              </td>

              <!-- Lookup -->
              <td class="text-center">
                <ng-container *ngIf="p.isMapped; else notMapped">
                  {{ p.lookUp ? 'Yes' : 'No' }}
                </ng-container>
              </td>

            </tr>
          </tbody>

        </table>

        <ng-template #notMapped>
          <span class="text-muted">-</span>
        </ng-template>

      </div>

      <!-- ================= FOOTER ================= -->
      <div class="modal-footer">
        <button class="btn btn-default" (click)="hide()">Close</button>
      </div>

    </div>
  </div>
</div>